export const TreeCustomer = {
	allCustomers: "allCustomers",
	identCustomers: "identCustomers",
}

export const treeOptions = {
	allChannels: "channels",
	stores: "stores",
	eCommerce: "ecommerce",
}

const sizeX = 350
const sizeY = 280
const width = 470
const height = 400

const factorPositionXTraslate = 2.3
const factorPositionYTraslate = 15

const factorPositionForeignX = -225
const factorPositionForeignY = -300
const factorPositionForeignXSafari = -150
const factorPositionForeignYSafari = -100
export const nodeSize = { x: sizeX, y: sizeY }

export const separation = { siblings: 1, nonSiblings: 1 }

export const translateConf = {
	x: window.innerWidth / factorPositionXTraslate,
	y: window.innerWidth / factorPositionYTraslate,
}
export const isSafari = (safari: any, notSafari: any) => {
	const IS_SAFARI =
		/Safari/.test(navigator.userAgent) &&
		/Apple Computer/.test(navigator.vendor)
	if (IS_SAFARI) {
		return safari
	}
	return notSafari
}

export const foreignObjectProps = {
	width: width,
	height: height,
	x: isSafari(factorPositionForeignXSafari, factorPositionForeignX),
	y: isSafari(factorPositionForeignYSafari, factorPositionForeignY),
}

export const GROWTH_NODE = "growth"

export const MapperTitle = {
	Sales: "phronesis.transactional.application.growth-profiling.chart.sales",
	AvgTicket:
		"phronesis.transactional.application.growth-profiling.chart.avgticket",
	PricePerItem:
		"phronesis.transactional.application.growth-profiling.chart.priceperitem",
	ItemsPerVisit:
		"phronesis.transactional.application.growth-profiling.chart.itemspervisit",
	TotalItemsSold:
		"phronesis.transactional.application.growth-profiling.chart.totalitemssold",
	Transactions:
		"phronesis.transactional.application.growth-profiling.chart.Transactions",
	PurchaseFrequency:
		"phronesis.transactional.application.growth-profiling.chart.purchasefrequency",
	Reach: "phronesis.transactional.application.growth-profiling.chart.reach",
	TimeBtwPurchase:
		"phronesis.transactional.application.growth-profiling.chart.timebtw",
	Recency: "phronesis.transactional.application.growth-profiling.chart.recency",
	Customers:
		"phronesis.transactional.application.growth-profiling.chart.customers",
	SpendByCustomer:
		"phronesis.transactional.application.growth-profiling.chart.spend",
	Loading: "phronesis.transactional.application.growth-profiling.chart.loading",
}

export const MapperTooltip = {
	Sales:
		"phronesis.transactional.application.growth-profiling.chart.sales.tooltip",
	AvgTicket:
		"phronesis.transactional.application.growth-profiling.chart.avgticket.tooltip",
	PricePerItem:
		"phronesis.transactional.application.growth-profiling.chart.priceperitem.tooltip",
	ItemsPerVisit:
		"phronesis.transactional.application.growth-profiling.chart.itemspervisit.tooltip",
	TotalItemsSold:
		"phronesis.transactional.application.growth-profiling.chart.totalitemssold.tooltip",
	Transactions:
		"phronesis.transactional.application.growth-profiling.chart.Transactions.tooltip",
	PurchaseFrequency:
		"phronesis.transactional.application.growth-profiling.chart.purchasefrequency.tooltip",
	Reach:
		"phronesis.transactional.application.growth-profiling.chart.reach.tooltip",
	TimeBtwPurchase:
		"phronesis.transactional.application.growth-profiling.chart.timebtw.tooltip",
	Recency:
		"phronesis.transactional.application.growth-profiling.chart.recency.tooltip",
	Customers:
		"phronesis.transactional.application.growth-profiling.chart.customers.tooltip",
	SpendByCustomer:
		"phronesis.transactional.application.growth-profiling.chart.spend.tooltip",
	Loading: "phronesis.transactional.application.growth-profiling.chart.loading",
}
